import React, { useState, useRef } from 'react';
import ImportConversations from './ImportConversations';
import { RevokeAllKeys } from './RevokeAllKeys';
import { DeleteCache } from './DeleteCache';
import { useOnClickOutside } from '~/hooks';
import { ClearChats } from './ClearChats';
import SharedLinks from './SharedLinks';

function Data() {
  const dataTabRef = useRef(null);
  const [confirmClearConvos, setConfirmClearConvos] = useState(false);
  useOnClickOutside(
    dataTabRef,
    () => confirmClearConvos && setConfirmClearConvos(false),
    [],
  );

  return (
    <div className="text-text-primary flex flex-col gap-3 p-1 text-sm">
      <div className="bordered-item">
        <ImportConversations />
      </div>
      <div className="bordered-item">
        <SharedLinks />
      </div>
      <div className="bordered-item">
        <RevokeAllKeys />
      </div>
      <div className="bordered-item">
        <DeleteCache />
      </div>
      <div className="bordered-item">
        <ClearChats />
      </div>
    </div>
  );
}

export default React.memo(Data);
